module.exports = __webpack_public_path__ + "img/logo.45ef3bc5.png";